/*eslint-disable*/
/*=========================================================================================
  File Name: moduleAuthActions.js
  Description: Auth Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
/*eslint-enable*/

import { performFetch } from '../../helpers.js'

export default {
  addNavigationHistory({ commit }, payload) {
    commit('ADD_NAVIGATION_HISTORY', payload);
  },
  clearNavigationHistory({ commit }) {
    commit('CLEAR_NAVIGATION_HISTORY');
  },
  reloadState({ commit }) {
    commit('RELOAD_STATE');
  }
};
